import { useEffect, RefObject } from 'react';
import { useDispatch } from 'react-redux';
import { RESET_STATE_ACTION_TYPE } from 'src/store/reducers';
import ApplicationService from 'src/services/ApplicationService';
import useApplicationData from 'src/hooks/useApplicationData';
import usePlayerEvents from '../usePlayerEvents';

function usePlayer(videoElementRef: RefObject<HTMLVideoElement>) {
  const dispatch = useDispatch();
  const { createListeners } = usePlayerEvents();
  const applicationData = useApplicationData();

  useEffect(() => {
    if (!videoElementRef.current) return;

    ApplicationService.init(applicationData);
    ApplicationService.setPlayer(videoElementRef.current, createListeners);

    return () => {
      ApplicationService.clean();
      dispatch({ type: RESET_STATE_ACTION_TYPE });
    };
  }, []);
}

export default usePlayer;
